import { mockExchangeBalances } from '@/__mocks__';
import { individualApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} getters
   */
  async initExchangeDashboard({ commit, dispatch, getters }) {
    commit('reset');
    commit('setLoading', true);
    await dispatch('fetchAccount');
    const requests = getters['wallets'].map((wallet) =>
      dispatch('fetchBalance', wallet),
    );
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchAccount({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestMyAccount(token);
      commit('setAccount', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {String} wallet
   */
  fetchBalance({ commit }, wallet) {
    const coins = mockExchangeBalances();
    commit('addBalance', { wallet, coins });
  },
};
